<template>
    <div v-if="isNewNumber">
        <ur-dropdown v-if="sipNumberList.length > 0" v-model="row.sipNumber" :rules="dropdownRule" :items="sipNumberList" @input="onDropdownSelected" lazy placeholder="전화번호 선택" :noShake="true"/>
        <ur-dropdown v-else v-model="tempValue" :items="[{text:'선택할 수 있는 번호가 없습니다.',}]" placeholder="전화번호 선택" lazy :rules="invalidRule" :noShake="true"/>
    </div>
    <div v-else :class="getClass">
        {{getFormattedNumber()}}
    </div>
</template>
<script>
import Base from './CMP_AIS_00005_COMP_BASE';

export default {
    name:'CMP_AIS_00005_C01',
    extends:Base,
    components:{},
    props:{
        //props : ['row','value','text'], 
    },
    data(){
        return {
            dropdownRule:[
                v => (v != null && v != '') || '',
            ],
            invalidRule:[
                v => false || '',
            ],
            tempValue:null,
        }
    },
    created(){},
    mounted(){
    },
    computed:{
        isNewNumber(){
            if(this.row.isNewNumber && this.row.isNewNumber=== true) {
                return true;
            } else {
                return false;
            }
        },
        sipNumberList(){
            let parent = this.getComponent('ServiceRequestNewModal');
            return parent.sipNumberList(this.row);
        },
    },
    methods:{
        getFormattedNumber(){
            //console.log(this.getComponent());
            //this.getComponent().tdClass = [];

            //console.log(this.getComponent().tdClass);
            return aiccUtils.phoneNumberFormat.format(this.row.sipNumber);
        },
        onDropdownSelected(input){
            let parent = this.getComponent('ServiceRequestNewModal');
            //parent.items[this.row.__idx].oldSipNumber = parent.items[this.row.__idx].sipNumber;
            //parent.items[this.row.__idx].sipNumber = input;
            parent.onDropdownSelected(this.row.__idx, input);
            //parent.onDropdownSelected(parent.items[this.row.__idx]);
            //console.log(this.row);
            //console.log(parent.items[this.row.__idx].oldSipNumber + ' / ' + parent.items[this.row.__idx].sipNumber + ' / ' + input);
            //parent.items[this.row.__idx].oldSipNumber = parent.items[this.row.__idx].sipNumber;
            //parent.items[this.row.__idx].sipNumber = input;
            //parent.onDropdownSelected(this.row);
        },
    },
}
</script>